module.exports = __webpack_public_path__ + "img/header.1b5bef35.jpg";